import { UPDATE_TODAYS_INTAKE, UPDATE_INTAKE, UPDATE_INTAKE_HISTORY } from "./actionTypes";

export const updateTodaysIntake = (item) => {
  return {
    type: UPDATE_TODAYS_INTAKE,
    payload: item,
  };
};

export const updateIntake = (item) => {
  return {
    type: UPDATE_INTAKE,
    payload: item,
  };
};

export const setIntakeHistory = (item) => {
  return {
    type: UPDATE_INTAKE_HISTORY,
    payload: item,
  };
};
